import { render, staticRenderFns } from "./Concert.vue?vue&type=template&id=10d64c60"
import script from "./Concert.vue?vue&type=script&lang=js"
export * from "./Concert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports